import IconEcommerce from "./icon-ecommerce";

export default IconEcommerce;